<template>
  <v-app>
    <div class="row">
      <div class="col-md-12">
        <div class="card">
          <v-container fluid>
            <v-card-title>
              <!--            <v-btn @click="create = !create" class="btn-add-with-text" v-status="'content_create'">-->
              <!--              <v-icon>mdi-plus</v-icon>-->
              <!--              ثبت تاریخچه ی جدید-->
              <!--            </v-btn>-->
              <!--              <v-spacer/>-->
              <!--              {{ $t($route.meta.title) }}-->
              <!--              <v-spacer/>-->
              <!--              <v-btn :loading="loading" @click="reloadTable(tableProps)" class="btn-update">-->
              <!--                <v-icon>mdi-update</v-icon>-->
              <!--                به روز رسانی-->
              <!--              </v-btn>-->
            </v-card-title>
            <v-divider />

            <div class="row">
              <div class="col-md-12 p-5">
                <data-table
                  orderDir="desc"
                  :data="data"
                  :columns="columns"
                  :translate="translates"
                  :per-page="perPages"
                  @on-table-props-changed="reloadTable"
                >
                </data-table>
              </div>
            </div>
          </v-container>
        </div>
      </div>
    </div>
  </v-app>
</template>

<script>
import Button from "@/view/pages/Button.vue";

export default {
  name: "UserNotification",
  data() {
    return {
      loading: false,
      columns: [
        {
          label: "ردیف",
          transform: (val) => {
            let row = this.data.current_page - 1;
            row = row * this.data.per_page;
            return row + val.row + 1;
          },
        },
        {
          name: "id",
          label: "شناسه",
          orderable: true,
        },
        {
          label: "کاربر",
          name: "user_id",
          transform: ({ data }) => {
            if (data.type === "CustomerHistory")
              return (
                data.data.customer.first_name +
                " " +
                data.data.customer.last_name
              );
            return data.data.user.name + " " + data.data.user.lastName;
          },
        },
        {
          label: "پشتیبان",
          name: "support",
          transform: (val) => {
            return val.data.data.owner.username;
          },
        },
        {
          label: "نوع اعلان ",
          name: "type",
          transform: ({ data }) => {
            if (data.type === "CustomerHistory")
              return `<div class="badge badge-success">مشتریان</div>`;
            return `<div class="badge badge-danger">کاربران</div>`;
          },
        },
        {
          label: "نوع تاریخچه",
          name: "type",
          transform: (val) => {
            return val.data.data.type;
          },
        },
        {
          label: "عنوان تاریخچه",
          name: "title",
          transform: (val) => {
            return val.data.data.title;
          },
        },
        {
          label: "عملیات",
          name: "actions",
          handler: this.actions,
          component: Button,
          event: "action",
          meta: {
            permission_prefix: "content_",
            buttons: [
              {
                name: "show",
                label: "نمایش",
                icon: "eye",
                class: "btn-show",
              },
            ],
          },
        },
      ],
      data: {},
      tableProps: {
        search: "",
        length: 10,
        column: "id",
        dir: "desc",
      },
      url: "user/notifications",
    };
  },
  mounted() {
    this.getUserNotifications();
  },
  methods: {
    getUserNotifications(url = this.url, query = this.tableProps) {
      this.loading = true;
      this.requestApiGet(url, query)
        .then(({ data }) => {
          this.loading = false;
          this.data = data;
        })
        .catch(({ response }) => {
          this.loading = false;
        });
    },
    reloadTable(tableProps) {
      this.getUserNotifications(this.url, tableProps);
    },
    actions(data, type) {
      this[type](data);
    },
    show(data) {
      if (data.type === "User")
        return this.$router.push({
          name: "admin.users.history",
          params: { phone: data.data.phone_number },
          query: { notifId: data.id },
        });
      return this.$router.push({
        name: "admin.customers.history",
        params: { phone: data.data.phone_number },
        query: { notifId: data.id },
      });
    },
  },
};
</script>

<style scoped></style>
